import * as React from 'react'
import * as logger from '@owl-nest/logger'

export type Entry = {
  id: string
  subject: string
  created_at: string
  updated_at: string
  slug: string
  url: string
  list_ids: string[]
}

export type State =
  | {
      status: 'pristine'
    }
  | {
      status: 'waiting'
    }
  | {
      status: 'success'
      list: Entry[]
    }
  | {
      status: 'failure'
      error: any
    }

export function useArchives() {
  const [state, setState] = React.useState<State>({
    status: 'pristine',
  })

  React.useEffect(() => {
    getArchives()
  }, [])

  return state

  async function getArchives() {
    setState({ status: 'waiting' })

    try {
      const response = await fetch('https://newsletters.bienoubien.com/api?list_id=XvRpUz,QYsEhW,V9pTiL')
      const list: Entry[] = await response.json()

      setState({
        status: 'success',
        list: list.slice(0, 5),
      })
    } catch (error: any) {
      logger.err("[newsletter] Couldn't retrieve archives", { error })
      setState({
        status: 'failure',
        error,
      })
    }
  }
}
